import classNames from "classnames";
import React from "react";
import Button from "../../atoms/Button/Button";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Close } from "@mui/icons-material";

interface DrawerProps {
  isOpen: boolean;
  children?: React.ReactNode;
  widthRefElID?: string;
  className?: string;
  hasCollapseButton?: boolean;
  lightTheme?: boolean;
  onClose: () => void;
}

const Drawer = (props: DrawerProps) => {
  const {
    isOpen,
    children,
    widthRefElID,
    className,
    hasCollapseButton = true,
    lightTheme = false,
    onClose,
  } = props;

  const componentClassName = classNames(
    "dui-drawer",
    {
      "dui-drawer-open": isOpen,
      "dui-drawer-light-theme": lightTheme,
      "dui-drawer-has-collapse-button": hasCollapseButton,
    },
    className
  );

  let drawerWidth = undefined;

  if (widthRefElID !== undefined) {
    const widthRefEl = document.getElementById(widthRefElID);
    if (widthRefEl) {
      drawerWidth = widthRefEl.offsetWidth;
    }
  }
  return (
    <div
      className={componentClassName}
      style={drawerWidth ? { width: drawerWidth } : undefined}
    >
      {hasCollapseButton && (
        <Button
          onClick={() => onClose()}
          className="dui-drawer-close"
          type="text"
        >
          <ChevronRightIcon />
        </Button>
      )}
      <Button
        icon={<Close />}
        onClick={() => onClose()}
        className="dui-drawer-close-x"
        corners="rounded"
      />
      {isOpen && <div className="dui-drawer-inner">{children}</div>}
    </div>
  );
};

export default Drawer;
